import { SET_MESSAGE_SCREEN_BLOCKER_ACTION_TYPE } from './actions';

const defaultState = {
  message: null,
};

const ScreenBlockerReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_MESSAGE_SCREEN_BLOCKER_ACTION_TYPE: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};

export default ScreenBlockerReducer;
